import React, { useEffect, useState } from "react";
import { Form, Modal, Row, Col, Button, Tabs, Tab } from "react-bootstrap";
import { getUser } from "../../../services/authService";
import {
  sendReasonsToJD,
  sendBulkReasonsToJD,
  insertBookingNumber,
  insertBulkTractorBookingNumber,
  updateBulkTractorBookingNumberWithReason,
  updateBookingNumber,
  getDailyContainerPlanningAB,
  updateReasonsToJD,
  sendBulkReasonsforhold
} from "../../../services/tractorDataService";
import Select from "react-select";
import { toast } from "react-toastify";
import { dispatcher } from "../../../store/storeHelpers";
import {
  TRACTOR_BOOKING_DONE,
  TRACTOR_BOOKING_LOADED,
  TRACTOR_BOOKING_SENT_FOR_APPROVAL,
  TRACTOR_BOOKING_UPDATED,
} from "../../../store/ActionTypes";
import { includes } from "lodash";
import moment from "moment";
import { tractorDataCreatorForStore } from "../../../utils/dataFilter";
// import { bookingUpdateEmailRecepients,CC_bookingUpdateEmailRecepients, htmlEmailSend } from "../../../services/emailService";
// import { getBookingBody } from "../../../email-template/planUploadMail";

function BookingModal({
  show,
  handleClose,
  data,
  reasons,
  selectedFlatRows,
  date,
  countData,
  setCountData,
  allowToHold,
  showholddialog,
  setholdmodal,
}) {
  const [shipmentData, setShipmentData] = useState({
    DailyContainerPlanningId: data.DailyContainerPlanningId,
    Market: data.Market,
    BookingNo: "",
    BookedBy: getUser().uid,
  });
  const [loading, setLoading] = useState(false);
  const [sendForApproval, setSendForApproval] = useState({});
  const [key, setKey] = useState("book");
  const [bookingReason, setBookingReason] = useState("");
  const [disableBooking, setDisableBooking] = useState(false)
  const [holdreason,setholdreason] = useState("");
  const [holdpayload,setholdpayload] = useState();
  const [step,setstep] = useState(1);
 
  

  useEffect(() => {
    setShipmentData({
      DailyContainerPlanningId: data.DailyContainerPlanningId,
      Market: data.Market,
      BookingNo: "",
      BookedBy: getUser().uid,
    });

    setholdpayload({
      dailyContainerPlanningId:
    data.DailyContainerPlanningId,
    reason: "",
    userId: getUser().uid,
    isHold:1,
    type:"Tractor",
    userId:getUser().uid,
    })
    setSendForApproval({
      DailyContainerPlanningId: data.DailyContainerPlanningId,
      AssignContainerPlanningId: data.AssignContainerId,
      Market: data.Market,
      Reason: "",
      manualReason: "",
      SendApprovalBy: getUser().uid,
    });

    if(shipmentData.BookingNo === ""){
      setDisableBooking(true)
    }
    else{
      setDisableBooking(false)
    }
  }, [data]);

  const planningId = [];
  for (let i = 0; i < selectedFlatRows.length; i++) {
    if (selectedFlatRows[i].originalSubRows.length === 0) {
      if (selectedFlatRows[i].original.Container_Count !== "") {
        if (!includes(planningId, selectedFlatRows[i].original)) {
          planningId.push(selectedFlatRows[i].original);
        }
      }
    }
  }
  if(showholddialog && step===1){
    if(showholddialog===data?.DailyContainerPlanningId){
       if(data?.STATUS==="Hold"){
        setstep(2);
      } 

    }
    
  }

  function showBookingLabel(counterValue) {
    let labelArray = []
    Object.keys(counterValue).map((item)=>{
      if(counterValue[item] !== 0){
        labelArray.push(item)
      }
    })
    return labelArray
  }
  function showPendingLabel(counterValue) {
    let labelArray = []
    Object.keys(counterValue).map((item)=>{
      if(counterValue[item] !== 0){
        labelArray.push(item)
      }
    })
    return labelArray
  }
  const handleTextChange = (e) => {
    setShipmentData({ ...shipmentData, [e.target.name]: e.target.value });
    if(e.target.value.length === 0){
      setDisableBooking(true)
    }else{
      setDisableBooking(false)
    }
  };

  let counterLabel = []
  let counterValue = {
    Booked: 0,
    Pending: 0,
    Approved: 0,
    Cancelled: 0,
    Not_Booked: 0,
    Hold:0,
  }
  const handleBookingDone = async () => {
    const payload = planningId.map((item) => {
      return {
        DailyContainerPlanningId: item.DailyContainerPlanningId,
        Booking_Number: shipmentData.BookingNo,
        Market: item.Market,
        Created_By: getUser().uid,
      };
    });

    try {
      setLoading(true);

      if (data.Reason || data.AssignContainerId) {
        if (selectedFlatRows.length === 0) {
          await updateBookingNumber({
            ...shipmentData,
            AssignContainerId: data.AssignContainerId,
          });
          dispatcher(TRACTOR_BOOKING_UPDATED, {
            ...shipmentData,
            AssignContainerId: data.AssignContainerId,
          });
        } else {
          await updateBulkTractorBookingNumberWithReason(payload);
          const response = await getDailyContainerPlanningAB(
            moment(date).format("YYYY-MM-DD")
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
          dispatcher(
            TRACTOR_BOOKING_LOADED,
            tractorDataCreatorForStore(response.data.Resultset1)
          );
        }
      } else {
        if (selectedFlatRows.length === 0) {
          const apiresponse = await insertBookingNumber(shipmentData);
          dispatcher(TRACTOR_BOOKING_DONE, {
            ...shipmentData,
            AssignContainerId: apiresponse.data.Result,
          });
          const response = await getDailyContainerPlanningAB(
            moment(date).format("YYYY-MM-DD")
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
        
        } else {
          await insertBulkTractorBookingNumber(payload);
          const response = await getDailyContainerPlanningAB(
            moment(date).format("YYYY-MM-DD")
          );
          dispatcher(
            TRACTOR_BOOKING_LOADED,
            tractorDataCreatorForStore(response.data.Resultset1)
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
        }
      }
      setLoading(false);
      handleClose();
      toast.success("Booking done successfully.");
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 400) {
        toast.error("Error while booking please try again");
      }
    }
  };

  const handleBookingError = async () => {
    var _jsonTracBookingReson = [];
    try {
      if (!data.AssignContainerId) {
        if (selectedFlatRows.length === 0) {
          setLoading(true);
          const apiresponse = await sendReasonsToJD(sendForApproval);
          dispatcher(TRACTOR_BOOKING_SENT_FOR_APPROVAL, {
            ...sendForApproval,
            AssignContainerId: apiresponse.data.Result,
          });
          const response = await getDailyContainerPlanningAB(
            moment(date).format("YYYY-MM-DD")
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})

        } else {
          if (
            sendForApproval.Reason === "" &&
            sendForApproval.manualReason !== ""
          ) {
            for (let i = 0; i < planningId.length; i++) {
              _jsonTracBookingReson.push({
                DailyContainerPlanningId:
                  planningId[i].DailyContainerPlanningId,
                Reason: sendForApproval.manualReason,
                SendApprovalBy: getUser().uid,
              });
            }
          } else if (
            sendForApproval.Reason !== "" &&
            sendForApproval.manualReason !== ""
          ) {
            for (let i = 0; i < planningId.length; i++) {
              _jsonTracBookingReson.push({
                DailyContainerPlanningId:
                  planningId[i].DailyContainerPlanningId,
                Reason: `${sendForApproval.Reason},${sendForApproval.manualReason}`,
                SendApprovalBy: getUser().uid,
              });
            }
          } else {
            for (let i = 0; i < planningId.length; i++) {
              _jsonTracBookingReson.push({
                DailyContainerPlanningId:
                  planningId[i].DailyContainerPlanningId,
                Reason: sendForApproval.Reason,
                SendApprovalBy: getUser().uid,
              });
            }
          }
          setLoading(true);
          await sendBulkReasonsToJD(_jsonTracBookingReson);
          const response = await getDailyContainerPlanningAB(
            moment(date).format("YYYY-MM-DD")
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
          dispatcher(
            TRACTOR_BOOKING_LOADED,
            tractorDataCreatorForStore(response.data.Resultset1)
          );
        }
      }else{
        if (selectedFlatRows.length === 0) {
          setLoading(true);
          await updateReasonsToJD(sendForApproval);
          dispatcher(TRACTOR_BOOKING_SENT_FOR_APPROVAL, {
            ...sendForApproval
          });
        }
      }
      setLoading(false);
      handleClose();
      toast.warn("Booking sent for approval to John deere");
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 400) {
        toast.error("Error while sending approval please try again");
      }
    }
  };

  const holdBooking = async () => {
    var _jsonUpdateBulkHoldStatus_AryabhattaList = [];
    if(selectedFlatRows.length === 0){
      _jsonUpdateBulkHoldStatus_AryabhattaList.push({
        ...holdpayload,
        reason:holdreason,
        isHold:step=== 1 ? 1 : 0,
      });
    }
    else{
      for (let i = 0; i < planningId.length; i++) {
        _jsonUpdateBulkHoldStatus_AryabhattaList.push({
          dailyContainerPlanningId:
                      planningId[i].DailyContainerPlanningId,
                    reason: holdreason,
                    userId: getUser().uid,
                    isHold:step===1 ? 1 : 0,
                    type:"Tractor",
                    userId:getUser().uid,
                  });
                }
    }
             if(_jsonUpdateBulkHoldStatus_AryabhattaList){
    try{
           setLoading(true) 
        const holdresponse = await sendBulkReasonsforhold(_jsonUpdateBulkHoldStatus_AryabhattaList); 
        const response = await getDailyContainerPlanningAB(
          moment(date).format("YYYY-MM-DD")
        );
        for (let i = 0; i < response.data.Resultset2.length; i++) {
          counterLabel.push(response.data.Resultset2[i]["STATUS"])
          if(response.data.Resultset2[i]["STATUS"] === "Booked"){
            counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
            counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Pending"){
            counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Approved"){
            counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
            counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Hold"){
            counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
          }
        }
        setCountData({label : counterLabel, counterData : counterValue})
        dispatcher(
          TRACTOR_BOOKING_LOADED,
          tractorDataCreatorForStore(response.data.Resultset1)
        ); 
        setLoading(false)
        setholdmodal("")
        setstep(1);
        toast.success(step===1?"Booking hold successful":"Booking unhold successful")

    }
    catch(e){
     toast.error("Something went wrong")
      setLoading(false)
    }
  } 

  }


  return (
    <>

   <Modal show={show} onHide={handleClose} centered>
      <Modal.Body>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="book" title="Book">
            <h4>Booking Done</h4>
            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Control
                  name="BookingNo"
                  onChange={handleTextChange}
                  placeholder="enter booking no"
                />
              </Form.Group>
            </Row>
            <Button
              className="fr btn btn-sm"
              onClick={handleBookingDone}
              disabled={loading || disableBooking}
            >
              {loading ? "Booking" : "Book"}
            </Button>
          </Tab>
         
          {!data.Reason && (
            <Tab eventKey="error" title="Send for approval">
              <h4>Send for approval</h4>
              <Row>
                <Select
                  options={reasons}
                  getOptionLabel={(option) => option.Reason}
                  getOptionValue={(option) => option.ReasonMasterId}
                  className="form-selector mb-3"
                  onChange={(option) =>
                    setSendForApproval({
                      ...sendForApproval,
                      Reason: option.Reason,
                    })
                  }
                />
                <Form.Group as={Col} className="mb-3">
                  <Form.Control
                    name="BookingReason"
                    value={bookingReason}
                    onChange={(e) => {
                      setBookingReason(e.target.value);
                      setSendForApproval({
                        ...sendForApproval,
                        manualReason: e.target.value,
                      });
                    }}
                    placeholder="Enter the reason..."
                  />
                </Form.Group>
              </Row>
              <Button
                className="fr btn btn-sm"
                onClick={handleBookingError}
                disabled={loading}
              >
                {loading ? "Sending" : "Send"}
              </Button>
            </Tab>
            
            
          )}
           
        </Tabs>
      </Modal.Body>
    </Modal>


<Modal  show={showholddialog===data.DailyContainerPlanningId} onHide={()=>{setholdmodal("")}} 
     className="DeleteModal"
     dialogClassName="deleteWidthClass"
     contentClassName="deleteHeightClass" centered>
  <Modal.Header   style={step===2 ?{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }:null}>

  {step===1 && <h4>Hold Booking</h4>}
  {step===2 && <div className="DeleteModal__title">Alert</div>}

  </Modal.Header>
      <Modal.Body>
      {step===2 && <center><div className="DeleteModal__description">Do you want to unhold this plan ?</div></center>}
            {step===1 && <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Control
                  name="Holdbooking"
                  as="textarea"
                  rows={3}
                  maxLength={200}
                  onChange={(e)=>setholdreason(e.target.value)}
                  placeholder="Enter the reason..."
                  style={{resize:"none"}}
                />
              </Form.Group>
            </Row>}
         {step===1 && <Button
              className="fr btn btn-sm"
              onClick={()=>holdBooking()}
              disabled={loading || !holdreason}
            >
             { loading ? "Holding..": "Hold"}
            </Button>
            }

            {
              step==2 && 
              <div className="DeleteModal__Btn">
           
                <Button
       className="DeleteModal__noBtn"
              onClick={()=>setholdmodal("")}
              disabled={loading}

             
            >
             {"No"}
            </Button>
            <Button
               className="DeleteModal__yesBtn"
              onClick={()=>holdBooking()}
              disabled={loading}
        
            >
             {"Yes"}
            </Button>
            </div>
            }
      </Modal.Body>
    </Modal>

    </>

  );
}

export default BookingModal;
